import { defaultColorSet } from "@/settings/colors";
import heatmapTableMetrics from "@/settings/metrics/heatmapTableMetrics";
import dimensionMetrics from "@/settings/metrics/planDimensionMetrics";
import displayMetrics from "@/settings/metrics/planDisplayMetrics";
import dualDimensionMetrics from "@/settings/metrics/planDualDimensionMetrics";
import tableMetrics from "@/settings/metrics/planTableMetrics";
import timeMetrics from "@/settings/metrics/planTimeMetrics";
import { timeGranularity } from "@/settings/tableSettings";
import { InputDictionary, PlanInputDictionary } from "@/types/common";

export default <Record<string, InputDictionary[] | PlanInputDictionary[]>>{
  legendPositions: [
    { title: "Bottom", value: "bottom" },
    { title: "Top", value: "top" },
    { title: "Left", value: "left" },
    { title: "Right", value: "right" },
  ],
  frequency: [
    { title: "Year", value: "year" },
    { title: "Quarter", value: "quarter" },
    { title: "Month", value: "month" },
    { title: "Week", value: "week" },
    { title: "Date", value: "date" },
  ],

  summaryTrendOptions: [
    { title: "Period over period", value: "pop" },
    { title: "Year over year", value: "yoy" },
  ],

  colors: defaultColorSet.map((value) => ({ title: value, value })),

  percents: [
    { title: "10%", value: 10 },
    { title: "20%", value: 20 },
    { title: "30%", value: 30 },
    { title: "40%", value: 40 },
    { title: "50%", value: 50 },
    { title: "60%", value: 60 },
    { title: "70%", value: 70 },
    { title: "80%", value: 80 },
    { title: "90%", value: 90 },
  ],

  pieScales: [
    { title: "100%", value: 100 },
    { title: "75%", value: 75 },
    { title: "50%", value: 50 },
    { title: "25%", value: 25 },
  ],

  lineThickness: [
    { title: "1", value: 1 },
    { title: "2", value: 2 },
    { title: "3", value: 3 },
    { title: "4", value: 5 },
  ],

  waffleBricks: [
    { title: "4", value: 4 },
    { title: "8", value: 8 },
    { title: "16", value: 16 },
    { title: "32", value: 32 },
  ],

  showItems: [
    { title: "All", value: null },
    { title: "Top 5", value: 5 },
    { title: "Top 8", value: 8 },
    { title: "Top 10", value: 10 },
  ],

  metricSources: [
    { title: "Plan", value: "plan" },
    { title: "Explore", value: "explore" },
  ],

  dimensionMetrics,
  dualDimensionMetrics,
  displayMetrics,
  tableMetrics,
  heatmapTableMetrics,
  nullableDisplayMetrics: [
    {
      title: "",
      value: null,
    },
    ...displayMetrics,
  ],
  timeMetrics,
  summaryMetrics: displayMetrics,
  timeGranularity,
  bubbleLabelFields: [
    { title: "Decomposition Metric", value: "decompositionMetric" },
    { title: "Horizontal Axis", value: "xAxis" },
    { title: "Vertical Axis", value: "yAxis" },
  ],
  scatterLabelFields: [
    { title: "Horizontal Axis", value: "xAxis" },
    { title: "Vertical Axis", value: "yAxis" },
  ],

  dataLabelsSizes: [
    { title: "Tiny", value: 10 },
    { title: "Small", value: 12 },
    { title: "Medium", value: 14 },
    { title: "Large", value: 16 },
  ],

  lineDataLabelsSizes: [
    { title: "Tiny", value: 10 },
    { title: "Small", value: 12 },
    { title: "Medium", value: 14 },
    { title: "Large", value: 16 },
  ],
};
